import { render, staticRenderFns } from "./UsersManagement.vue?vue&type=template&id=1d97b788&scoped=true"
import script from "./UsersManagement.vue?vue&type=script&lang=js"
export * from "./UsersManagement.vue?vue&type=script&lang=js"
import style0 from "./UsersManagement.vue?vue&type=style&index=0&id=1d97b788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d97b788",
  null
  
)

export default component.exports